import moment from 'moment';

const longMonth = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

export const formatDate = (d: Date) => {
  const month = longMonth[d.getMonth()];
  return `${d.getDate()} ${month} ${d.getFullYear()}`;
};

export function formatDateString(dateString: string) {
  const date = new Date(dateString);
  const monthName = longMonth[date.getMonth()];
  return `${date.getDate()} ${monthName} ${date.getFullYear()}`;
}

export function formatTimeString(dateStr: string) {
  return moment(dateStr).local().format('hh:mma');
}
